import { css } from '@emotion/core';

export const searchBoxMenuItemContentCSS = css`
    display: flex;
    gap: 0.75rem;
`;
